module.exports = __webpack_public_path__ + "static/blog78-9dd874a4adb1b8397081fb575f00fd01.png";